export const callHistoryFilters = {
  date: {
    name: 'date',
    serialize: (v) => v.join(),
    deserialize: (v) => (v ? v.split(',') : []),
  },
  companyId: {
    name: 'companyId',
    serialize: (v) => (v && !isNaN(v) ? v : null),
    deserialize: (v) => (v && !isNaN(Number(v)) ? Number(v) : v),
  },
  operatorId: {
    name: 'operatorId',
    serialize: (v) => (v && !isNaN(v) ? v : null),
    deserialize: (v) => (v && !isNaN(Number(v)) ? Number(v) : v),
  },
  requestId: {
    name: 'requestId',
    serialize: (v) => (Boolean(v) ? v : null),
    deserialize: (v) => v || '',
  },
  phone: {
    name: 'phone',
    serialize: (v) => (Boolean(v) ? v : null),
    deserialize: (v) => v || '',
  },
};
